import React from 'react';
import { Redirect } from 'react-router-dom';
import * as storageService from './storage';

const withAuth = (Component) => {
  const Authenticate = (props) => {
    const user_current = storageService.getCurrentUser();

    if (!user_current) {
      return <Redirect to="/login" />;
    }

    return <Component {...props} />;
  };

  return Authenticate;
};

export { withAuth };
